var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-text-field",
    _vm._b(
      {
        staticClass: "text-field-numeric",
        attrs: {
          type: "tel",
          "prepend-inner-icon": "mdi-minus",
          "append-icon": "mdi-plus"
        },
        on: {
          change: _vm.setValue,
          input: function($event) {
            return _vm.setValue($event, true)
          },
          "click:append": function($event) {
            _vm.setValue(Number(_vm.value) + _vm.step)
          },
          "click:prepend-inner": function($event) {
            _vm.setValue(Number(_vm.value) - _vm.step)
          }
        }
      },
      "v-text-field",
      Object.assign({}, _vm.$attrs, _vm.$props, { class: "" }),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }